import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../actions/index';
import ButtonDesign from "../components/ButtonDesign";
import {getData, LOGIN} from "../util/storage";
import {isEmpty} from "../util/utility";
import {getEncryptedIdForBroadcaster} from "../util/broadcast_util"
import ContentLoader from "react-content-loader"
import CardComponent from "../components/CardComponent"
import * as _ from 'lodash'
import { Redirect } from 'react-router';

class SimilarBroadcastersList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            broadcaster: props.broadcasterData,
            trendingBroadcastersList: null,
            similarBroadcastersList: [],
            tagsData: null,
            redirect:false
        }
    }


    componentDidMount() {
        //every time the dashboard is loaded we check if the user api_token and token is available
        //it the api_token and token is available we do hit getUserDetails Webservice
        if (this.props.hasOwnProperty("tagsData")) {
            const json = this.props.tagsData
            this.setState({
                tagsData: this.props.tagsData
            })

            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        this.props.getListOfSimilarBroadcasters(data.token, data.api_token, json)
                    }else{
                        this.props.getListOfSimilarBroadcasters(null, null, json)
                    }
                })
        }

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // Check if props has tagData passed from broadcaster detail screen and is that data similar to current scope of tagsData. If not then set it to current state
        if (nextProps.hasOwnProperty("tagsData")) {
            if (this.state.tagsData != null && JSON.stringify(this.state.tagsData) !== JSON.stringify(nextProps.tagsData)) {
                this.setState({
                    tagsData: nextProps.tagsData
                })
                getData(LOGIN)
                    .then((data) => {
                        if (!isEmpty(data)) {
                            const json = this.state.tagsData

                            this.props.getListOfSimilarBroadcasters(data.token, data.api_token, json)
                        }
                    })
            }
        }

        if (nextProps.broadcaster_detail_management && nextProps.broadcaster_detail_management.similarBroadcasters) {
            this.setState({
                similarBroadcastersList: nextProps.broadcaster_detail_management.similarBroadcasters.data.data
            })
        }
    }

    onClickOfBroadcast = (broadcaster_id) => (e) => {
        this.props.history.push(`/broadcast/${getEncryptedIdForBroadcaster(broadcaster_id)}`);
    }


    render() {

        if (this.state.redirect) {
            return <Redirect push to="/similar-broadcasters" />;
        }

        return (
            <div className="col-xl-4 col-lg-12 related-broadcasts-sidebar">
                <div>
                    <div><div className="related-title">Related</div></div>
                    <div className="related-title-bottom"/>
                    {/*<div><p className="see-all"><Link to="/similar-broadcasters" href="#" title="See all">See all</Link></p></div>*/}
                </div>
                {
                    this.props.broadcaster_detail_management.isFetching && this.state.similarBroadcastersList.length === 0 ?
                        <ContentLoader height={240}
                                       speed={1}
                                       primaryColor="#f3f3f3"
                                       secondaryColor="#ecebeb">

                            <rect x="10" y="20" rx="4" ry="4" width="150" height="90"/>
                            <rect x="180" y="25" rx="4" ry="4" width="200" height="15"/>
                            <rect x="180" y="60" rx="4" ry="4" width="200" height="15"/>
                            <rect x="180" y="95" rx="4" ry="4" width="200" height="15"/>

                            <rect x="10" y="135" rx="4" ry="4" width="150" height="90"/>
                            <rect x="180" y="140" rx="4" ry="4" width="200" height="15"/>
                            <rect x="180" y="175" rx="4" ry="4" width="200" height="15"/>
                            <rect x="180" y="210" rx="4" ry="4" width="200" height="15"/>
                        </ContentLoader>
                        :
                        <div>
                            {
                                this.state.similarBroadcastersList && this.state.similarBroadcastersList.length > 0 &&
                                <div className="mt-2 related-broadcasts-list">
                                    {
                                        _.map(this.state.similarBroadcastersList, (data,index) => {
                                            return <CardComponent
                                                key={`similar-broadcast-${index}`}
                                                isRelated={true}
                                                isBadges={false}
                                                iconSize={3}
                                                bgColor={"#F7F7F7"}
                                                broadcastDetail={data}/>
                                        })
                                    }
                                    <ButtonDesign
                                        btName={"SHOW MORE"}
                                        btColor="link"
                                        btClass="text-decoration-none bg-white rounded-0 btn-with-shadow related-broadcasts-list-show-more-div"
                                        onclickFunction={() => this.setState({redirect: true})}
                                    />
                                </div>
                            }
                        </div>

                }

            </div>
        );
    }
}


function mapStateToProps(state, ownParams) {
    return {
        account_management: state.account_management,
        broadcaster_detail_management: state.broadcaster_detail_management
    };
}

export default connect(mapStateToProps, actions)(SimilarBroadcastersList);